// Status pill for the sources list. Maps SyncStatus -> tone + label.

import type { SyncStatus } from "./types";

const TONES: Record<SyncStatus, string> = {
  ok: "nominal",
  auth_failed: "danger",
  rate_limited: "flagged",
  partial: "flagged",
  skipped_unchanged: "neutral",
  never: "neutral",
};

const LABELS: Record<SyncStatus, string> = {
  ok: "ok",
  auth_failed: "auth failed",
  rate_limited: "rate limited",
  partial: "partial",
  skipped_unchanged: "unchanged",
  never: "never synced",
};

export function StatusBadge({ status }: { status: SyncStatus }) {
  return (
    <span
      className={`maisight-sources-badge maisight-sources-badge--${TONES[status]}`}
      data-status={status}
    >
      {LABELS[status]}
    </span>
  );
}
